import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useEnrolmentModal } from '../context/EnrolmentModalContext';

const CTA = () => {
  const { show } = useEnrolmentModal();
  return (
    <section id="admissions" className="relative py-24 md:py-32 overflow-hidden bg-[#0f0d0b] text-white">
      <div className="absolute inset-0">
        <img
          src="/school-photos/3.webp"
          alt="Whiteplains British School campus in Abuja"
          className="w-full h-full object-cover opacity-30 kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="tag-label justify-center"
          style={{ color: '#f0c95a' }}
        >
          Applications Open
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.8 }}
          className="font-serif-display text-5xl md:text-7xl font-black mt-6 leading-[1.05]"
        >
          Begin your family&apos;s
          <br />
          <span className="italic text-[#f0c95a]">Whiteplains journey.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-6 max-w-2xl mx-auto text-white/85 text-lg font-light leading-relaxed"
        >
          Meet our leadership, tour our facilities and discover the education that has shaped a
          generation of confident, curious and principled scholars.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-10 flex flex-wrap gap-4 justify-center"
        >
          <button type="button" onClick={() => show()} className="btn-primary">
            Request Prospectus <ArrowRight size={16} />
          </button>
          <button type="button" onClick={() => show({ message: 'I would like to book a campus tour.' })} className="btn-ghost-light">Book a Campus Tour</button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
